import { useCallback, useEffect, useState } from "react";
import { apiCall } from "services/api";

export const getUserProfile = async () => {
  const response = await apiCall({
    method: "GET",
    url: "/v1/user",
  });

  return response;
};

export const editUserProfile = async (data) => {
  const response = await apiCall({
    data,
    method: "PUT",
    url: "/v1/user",
  });

  return response;
};

export const changePassword = async (data) => {
  const response = await apiCall({
    data,
    method: "PUT",
    url: "/v1/user/password",
  });

  return response;
};

export const getCompanyProfile = async () => {
  const response = await apiCall({
    method: "GET",
    url: "/v1/user/company",
  });

  return response;
};

export const updateCompanyLogo = async (company_id, data) => {
  const response = await apiCall({
    data,
    method: "POST",
    url: `/v1/company/${company_id}/profile-picture`,
  });

  return response;
};

export const updateUserProfilePicture = async (data) => {
  const response = await apiCall({
    data,
    method: "POST",
    url: `/v1/user/profile-picture`,
  });

  return response;
};

export const getUserActivity = async (category) => {
  const response = await apiCall({
    method: "GET",
    url: `/v1/user/activity?category=${category}`,
  });

  return response;
};
export function useGetUserActivity({ category } = {}) {
  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(
    async ({ id: passedId } = {}) => {
      setLoading(true);
      try {
        const response = await apiCall({
          method: "GET",
          url: `/v1/user/activity?category=${category}`,
        });
        setResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    },
    [category],
  );

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { response, loading, error, refetch: fetchData };
}

export const getAdmin = async () => {
  const response = await apiCall({
    method: "GET",
    url: `/v1/user/administrator`,
  });

  return response;
};

export const createAccountInternal = async (data) => {
  const response = await apiCall({
    data,
    method: "POST",
    url: "/v1/user/administrator",
  });

  return response;
};

export const createAccountExternal = async (data) => {
  const response = await apiCall({
    data,
    method: "POST",
    url: "/v1/user",
  });

  return response;
};

export const getInternalAccountDetail = async (id) => {
  const response = await apiCall({
    method: "GET",
    url: `/v1/user/administrator/${id}`,
  });

  return response;
};

export const getExternalAccountDetail = async (id) => {
  const response = await apiCall({
    method: "GET",
    url: `/v1/user/management/${id}`,
  });

  return response;
};

export const updateAccountInternal = async (id, data) => {
  const response = await apiCall({
    data,
    method: "PUT",
    url: `/v1/user/administrator/${id}`,
  });

  return response;
};

export const updateAccountExternal = async (id, data) => {
  const response = await apiCall({
    data,
    method: "PUT",
    url: `/v1/user/management/${id}`,
  });

  return response;
};

export const deleteAccountInternal = async (id) => {
  const response = await apiCall({
    method: "DELETE",
    url: `/v1/user/administrator/${id}`,
  });

  return response;
};

export const getUserNotification = async (category) => {
  const response = await apiCall({
    method: "GET",
    url: `/v1/user/notification?limit=5&category=${category}`,
  });

  return response;
};

export const readUserNotification = async (notification_id) => {
  const response = await apiCall({
    method: "PUT",
    url: `/v1/user/notification?notification_id=${notification_id}`,
  });

  return response;
};

export const checkUserNotification = async (role) => {
  if (role === "ADMIN") {
    const clientNotifications = await getUserNotification("client");
    const adminNotifications = await getUserNotification("admin");

    if (
      clientNotifications?.data.length > 0 ||
      adminNotifications?.data.length > 0
    ) {
      return true;
    }
  } else if (role === "CLIENT") {
    const notifications = await getUserNotification();

    if (notifications?.data.length > 0) {
      return true;
    }
  }
  return false;
};
